import { render, staticRenderFns } from "./Sel.vue?vue&type=template&id=328e2b86&scoped=true"
import script from "./Sel.vue?vue&type=script&lang=js"
export * from "./Sel.vue?vue&type=script&lang=js"
import style0 from "./Sel.vue?vue&type=style&index=0&id=328e2b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e2b86",
  null
  
)

export default component.exports